<template>
    <div>
        <div class="topline">
            <h1>
                Min side <span>/</span>
                <span>Ordrer</span>
                <span>/</span> {{$route.params.id}}
            </h1>
        </div>
        <div class="pageLoad" v-if="loading">
            <div class="spinner"></div>
        </div>

        <v-layout row wrap v-if="order">
            <v-flex xs12>
                <div class="produktEkstra mb-3">
                    <span class="d-inline-block mr-5"><strong>Ordrenummer:</strong> {{order.order.ordrenummer}}</span>
                    <span class="d-inline-block mr-5"><strong>Dato:</strong> {{$moment(order.order.ordreDato).format('DD-MM-YYYY')}}</span>
                    <span v-if="invoice.invoice.eksterntBilagsNummer" class="d-inline-block mr-5"><strong>Reference:</strong> {{order.order.eksterntBilagsNummer}}</span>
                </div>
            </v-flex>
            <v-flex xs12>
                <a v-for="item in trackTrace" :href="item.trackTrace" target="_blank" class="trackTraceBtn">
                    Track and trace ({{$moment(item.shipment_Date).format('DD-MM-YYYY')}})
                </a>
            </v-flex>
            <v-flex xs12 sm4 v-for="item in invoice.orderLines" :key="item.nummer">
                <div class="produktEkstra fakturaList">
                    <ul>
                        <li>
                            <span class="fakturanummer"><strong>Varenr.</strong> {{item.nummer}}</span>
                        </li>
                        <li>
                            <span class="dato"><strong>Varebeskrivelse:</strong> {{item.beskrivelse}}</span>
                        </li>
                        <li v-if="item.discountText">
                            <span class="dato"><strong>Rabat:</strong> {{item.discountText}}</span>
                        </li>
                        <li>
                            <span class="ordrernummer"><strong>Antal:</strong> {{item.antal}}</span>
                        </li>
                        <li>
                            <span class="ordrernummer"><strong>Enhedspris:</strong> {{localNumber(item.enhedspris)}}</span>
                        </li>
                        <li>
                            <span class="fakturanummer"><strong>Totalpris:</strong> {{localNumber(item.beloeb)}}</span>
                        </li>
                    </ul>
                </div>
            </v-flex>
        </v-layout>


    </div>
</template>

<script>
    export default {
        data: () => ({
            order: null,
            trackTrace: [],
            loading: true
        }),
        components: {},
        computed: {

        },
        methods: {
            localNumber(n) {
                if (n) {
                    return parseFloat(parseFloat(n).toFixed(2)).toLocaleString("da", { minimumFractionDigits: 2 });
                } else {
                    return 0;
                }
            }
        },
        created() {
            this.$http.get("/api/profile/orders/" + this.$route.params.id).then(x => {
                this.order = x.data;

                this.$http.get("/api/profile/invoices/trackandtrace/" + this.$route.params.id).then(t => {
                    this.trackTrace = t.data;
                    this.loading = false;
                });
            });
        },
        mounted() {

        }
    }
</script>
